import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SessionService} from '../../../shared/services/session.service';
import {UserOrderService} from '../../../shared/services/user-order.service';
import {environment} from '../../../../environments/environment';
import {AppConstants} from '../../../shared/constants/app-constant';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-product-orders',
    templateUrl: './product-orders.component.html',
    styleUrls: ['./product-orders.component.scss']
})
export class ProductOrdersComponent implements OnInit {
    searchForm: FormGroup;
    filterForm: FormGroup;
    updateOrderForm: FormGroup;
    sessions: any = [];
    userOrders: any = [];
    submitting: any = false;
    orderStatus: any;
    orderDetail: any;
    submitted: any;
    imageBaseUrl: any = AppConstants.BUCKET_URL;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private fb: FormBuilder,
                private userOrderService: UserOrderService,
                public modalService: NgbModal,
                private sessionService: SessionService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'invoice_no': [''],
            'total_amount': [''],
            'order_status': [''],
            'member_id': [''],
            'member_name': [''],
            'start_date_time': [''],
            'end_date_time': ['']
        });
        this.filterForm = this.fb.group({
            'session_id': [''],
        });
        this.updateOrderForm = this.fb.group({
            'delivery_status': ['']
        });
        this.getSessions();
    }

    getSessions() {
        this.sessions = [];
        this.sessionService.get({'page': -1}).subscribe(data => {
            this.sessions = [];
            if (data && data['data'].length > 0) {
                this.sessions = data['data'];
                if (this.sessions && this.sessions.length > 0) {
                    this.sessions.forEach(session => {
                        if (session && session['status'] === 'ACTIVE' && session['default_session'] === 'ACTIVE') {
                            this.filterForm.patchValue({
                                'session_id': session['id']
                            });
                        }
                    });
                    this.get();
                }
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    get(params: any = {}) {
        this.submitting = true;
        if (this.searchForm.value && this.searchForm.value.start_date_time && !this.searchForm.value.end_date_time) {
            this.submitting = false;
            this.alertService.showErrors('Please choose End Date');
            return false;
        } else if (this.searchForm.value && !this.searchForm.value.start_date_time && this.searchForm.value.end_date_time) {
            this.submitting = false;
            this.alertService.showErrors('Please choose Start Date');
            return false;
        }
        params = {
            'page': this.pagination.page,
            'per_page': this.pagination.perpage,
            'session_id': (this.filterForm.value && this.filterForm.value.session_id),
            'start_date_time': (this.searchForm.value && this.searchForm.value.start_date_time) ? this.searchForm.value.start_date_time : '',
            'end_date_time': (this.searchForm.value && this.searchForm.value.end_date_time) ? this.searchForm.value.end_date_time : '',
            'invoice_no': (this.searchForm.value && this.searchForm.value.invoice_no) ? this.searchForm.value.invoice_no : '',
            'total_amount': (this.searchForm.value && this.searchForm.value.total_amount) ? this.searchForm.value.total_amount : '',
            'member_id': (this.searchForm.value && this.searchForm.value.member_id) ? this.searchForm.value.member_id : '',
            'member_name': (this.searchForm.value && this.searchForm.value.member_name) ? this.searchForm.value.member_name : '',
            'order_status': (this.searchForm.value && this.searchForm.value.order_status) ? this.searchForm.value.order_status : ''
        };
        this.userOrders = [];
        this.userOrderService.getProducts(params).subscribe(
            (data) => {
                if (data && data['data'].length > 0) {
                    this.userOrders = data['data'];

                    if (this.userOrders && this.userOrders.length > 0) {
                        this.userOrders.forEach((myOrder) => {
                            myOrder['open_status'] = false;
                            if (myOrder['products'] && typeof myOrder['products'] === 'string') {
                                try {
                                    myOrder['products'] = JSON.parse(myOrder['products']);
                                    if (myOrder['products'] && myOrder['products'].length > 0) {
                                        myOrder['products'].forEach((product) => {
                                            product['price'] =
                                                parseFloat(product['distributed_price']) * parseFloat(product['quantity']);
                                            product['total'] =
                                                product['price'] + product['price'] * (parseFloat(product['tax']) / 100);
                                        });
                                    }
                                } catch (error) {
                                    console.error('Error parsing JSON:', error);
                                    myOrder['products'] = [];
                                }
                            }
                        });
                    }
                }
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
                this.submitting = false;
            },
            (error) => {
                this.submitting = false;
            }
        );
    }

    changeDeliveryStatus(content, data) {
        this.orderStatus = data;
        this.orderStatus['products'].forEach(data => {
            this.orderDetail = data;
        });
        this.modalService.open(content, {'size': 'sm'});
    }

    updateOrderStatus() {
        const params = {
            'delivery_status': (this.updateOrderForm.value && this.updateOrderForm.value.delivery_status) ? this.updateOrderForm.value.delivery_status : '',
            'session_id': this.orderStatus?.session_id,
            'invoice_no': this.orderStatus?.invoice_no
        };
        this.submitted = true;
        if (this.updateOrderForm.value && this.updateOrderForm.value.delivery_status && this.updateOrderForm.value.delivery_status === 'DELIVERED') {
            this.userOrderService.orderDeliveredStatus(params, this.orderStatus?.unique_id).subscribe(data => {
                this.modalService.dismissAll('');
                this.get();
                this.submitted = false;
            }, error => {
                this.submitted = false;
            });
        } else if (this.updateOrderForm.value && this.updateOrderForm.value.delivery_status && this.updateOrderForm.value.delivery_status === 'CANCELLED') {
            this.userOrderService.orderCancelledStatus(params, this.orderStatus?.unique_id).subscribe(data => {
                this.modalService.dismissAll('');
                this.get();
                this.submitted = false;
            }, error => {
                this.submitted = false;
            });
        }
    }

    search() {
        this.get();
    }

    onPageChange(page) {
        this.pagination.page = page;
        this.get();
    }

    openExternalUrl(url) {
        window.open(environment.appUrl + url, '_blank');
    }

    downloadUserProductOrderReport(type) {
        this.submitting = true;
        if (this.searchForm.value && this.searchForm.value.start_date_time && !this.searchForm.value.end_date_time) {
            this.submitting = false;
            this.alertService.showErrors('Please choose End Date');
            return false;
        } else if (this.searchForm.value && !this.searchForm.value.start_date_time && this.searchForm.value.end_date_time) {
            this.submitting = false;
            this.alertService.showErrors('Please choose Start Date');
            return false;
        }
        const params = {
            'session_id': (this.filterForm.value && this.filterForm.value.session_id),
            'start_date_time': (this.searchForm.value && this.searchForm.value.start_date_time) ? this.searchForm.value.start_date_time : '',
            'end_date_time': (this.searchForm.value && this.searchForm.value.end_date_time) ? this.searchForm.value.end_date_time : '',
            'invoice_no': (this.searchForm.value && this.searchForm.value.invoice_no) ? this.searchForm.value.invoice_no : '',
            'total_amount': (this.searchForm.value && this.searchForm.value.total_amount) ? this.searchForm.value.total_amount : '',
            'member_id': (this.searchForm.value && this.searchForm.value.member_id) ? this.searchForm.value.member_id : '',
            'member_name': (this.searchForm.value && this.searchForm.value.member_name) ? this.searchForm.value.member_name : '',
            'order_status': (this.searchForm.value && this.searchForm.value.order_status) ? this.searchForm.value.order_status : '',
            'excel_type': type
        };
        if (params && params.start_date_time && !params.end_date_time) {
            this.alertService.showErrors('Please also select End Date');
            return false;
        } else if (params && !params.start_date_time && params.end_date_time) {
            this.alertService.showErrors('Please also select Start Date');
            return false;
        }
        this.userOrderService.downloadUserProductOrderReport(params).subscribe(dt => {
            if (dt && dt.url) {
                window.open(dt.url, '_blank');
            }
        });
    }
}
